import React from 'react';

export default function ObjetivosEstrategicos() {
  return (
    <div className="w-full bg-[#000] py-18 md:py-24 relative overflow-hidden bg-[url('/assets/cover-objetivos-estrategicos.png')] bg-cover bg-center bg-no-repeat">

      <div className="container mx-auto px-8 relative z-10">
        <h2 className="text-3xl md:text-5xl text-center mb-16 text-white">
          Objetivos <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">estratégicos</span>
        </h2>
        
        <div className="max-w-5xl mx-auto bg-[#FFFFFF17] backdrop-blur-sm border border-white/80 rounded-lg p-8 font-inter-regular text-center">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {/* Column 1 */}
            <div className="text-white p-4 relative">
              <p className="text-lg md:text-sm">
                Apoiar na formação de novos profissionais e incentivar pessoas com sinergia e engajamento conectadas ao nosso propósito.
              </p>
              {/* Vertical divider for desktop */}
              <div className="hidden md:block absolute right-0 top-0 bottom-0 w-px bg-[#C4C4C4]"></div>
              {/* Horizontal divider for mobile */}
              <div className="md:hidden w-[60%] h-px bg-[#C4C4C4] mt-12 mx-auto"></div>
            </div>
            
            {/* Column 2 */}
            <div className="text-white p-4 relative">
              <p className="text-lg md:text-sm">
                Nesta formação de talentos as empresas não são clientes, mas sim parceiros na geração de novos talentos.
              </p>
              {/* Vertical divider for desktop */}
              <div className="hidden md:block absolute right-0 top-0 bottom-0 w-px bg-[#C4C4C4]"></div>
              {/* Horizontal divider for mobile */}
              <div className="md:hidden w-[60%] h-px bg-[#C4C4C4] mt-12 mx-auto"></div>
            </div>
            
            {/* Column 3 */}
            <div className="text-white p-4 relative">
              <p className="text-lg md:text-sm">
                No Programa New Techs os clientes e a Projectiva apostam juntos e ganham juntos.
              </p>
              {/* Vertical divider for desktop */}
              <div className="hidden md:block absolute right-0 top-0 bottom-0 w-px bg-[#C4C4C4]"></div>
              {/* Horizontal divider for mobile */}
              <div className="md:hidden w-[60%] h-px bg-[#C4C4C4] mt-12 mx-auto"></div>
            </div>
            
            {/* Column 4 */}
            <div className="text-white p-4">
              <p className="text-lg md:text-sm">
                Os talentos agregam experiência na prática e ainda se monetizam.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
